import { Component, OnInit } from '@angular/core';


// cira services
import { VaService } from '../_services/va.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {
  
  constructor(public vaService: VaService , private router :Router) { }

  ngOnInit() {
    console.log(this.vaService)
    this.getUserRole(this.vaService.activeAgentInService);
    
  
  }
  getUserRole(agentId){
    
    this.vaService.getUserRole(agentId).subscribe(
      (Response : any)=>{
        
        if(Response.user.role =="instructor" && this.vaService.activeAgent['project_type'] != 'universal') {
          // this.router.navigate([ agentId,'instructor-dashboard']);
         
          this.router.navigate(["project",agentId,"instructor-dashboard"]);
        }
        
        // if(this.vaService.activeAgent['project_type'] == "universal"){
        //   //this.docUrl = environment.doc_url + "/Work Flows/";
        //   this.vaService.headingChangedEvent.emit({"heading":"Connect and Launch","docUrl":""});
        //   this.router.navigate(["project",agentId,"connect-bot"]);
        // }
    },
     
    (err)=>{
      console.log(err);
    });

  }
  
}
